module.exports = __webpack_public_path__ + "static/fonts/Fact-ExtraLightItalic.c065479.woff2";